import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createAffiliation } from '~/services/AgentHub/AgentService';

import { CreateAffiliationParams } from '~/types/services/agentHub';

import { affiliationsQueryKeys } from './useListAffiliations';

interface UseCreateAffiliationOptions {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export function useCreateAffiliation(options: UseCreateAffiliationOptions = {}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: CreateAffiliationParams) => {
      return await createAffiliation(params);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: affiliationsQueryKeys.all });
      options.onSuccess?.();
    },
    onError: (error: Error) => {
      options.onError?.(error);
    },
  });
}
